module.exports = __webpack_public_path__ + "static/media/download_banner.d72e86c8.jpg";